import useApiQuery from '@hooks/useApiQuery';
import QueryKeys from '@src/constants/queryKeys';

export default ({
  deviceType,
  options,
  queryKeys,
}: {
  deviceType: string;
  options: { enabled: boolean };
  queryKeys: string[];
}) =>
  useApiQuery<{ devices: { name: string; deviceId: string; type: string }[] }>({
    queryKey: [...queryKeys, QueryKeys.devicesParents],
    apiPath: `/devices/parents?deviceType=${deviceType}`,
    method: 'GET',
    useV2API: true,
    enabled: options.enabled,
  });
